export const STAMP_POSITIONS = [
  'topLeft',
  'topCenter',
  'topRight',
  'bottomLeft',
  'bottomCenter',
  'bottomRight',
] as const;

export type StampPosition = (typeof STAMP_POSITIONS)[number];

export const STAMPING_THEMES = [
  'blackOnWhite',
  'whiteOnBlack',
  'blackOnWhiteWithStroke',
  'whiteOnBlackWithStroke',
] as const;

export type StampingTheme = (typeof STAMPING_THEMES)[number];

export interface BatesRange {
  startNumber: number;
  endNumber: number;
  pageCount: number;
  fileName: string;
}

export interface StampingConfig {
  prefix: string;
  startNumber: number;
  digitCount: number;
  position: StampPosition;
  theme: StampingTheme;
  opacity: number;
  endorsement: string;
}

export function defaultStampingConfig(): StampingConfig {
  return {
    prefix: '',
    startNumber: 1,
    digitCount: 6,
    position: 'bottomRight',
    theme: 'blackOnWhite',
    opacity: 1,
    endorsement: '',
  };
}

export function isValidBatesRange(range: BatesRange): boolean {
  return range.endNumber >= range.startNumber && range.pageCount >= 1;
}

export function normalizeEndorsement(raw: string): string {
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .join('\n');
}
